import { createContext, MouseEvent } from 'react'
import { TeamMemberInvite } from 'src/interfaces/team'

export interface ITeamMemberInvitesTableContext {
  refreshTeamMemberInvites(): void

  actionAnchor: null | HTMLElement
  teamMemberInviteToAction: TeamMemberInvite | null
  openTeamMemberInviteItemAction(
    event: MouseEvent<HTMLButtonElement>,
    TeamMemberInvite: TeamMemberInvite,
  ): void
  closeTeamMemberInviteItemAction(): void
}

export const TeamMemberInvitesTableContext = createContext<ITeamMemberInvitesTableContext>({
  refreshTeamMemberInvites: () => {},

  actionAnchor: null,
  teamMemberInviteToAction: null,
  openTeamMemberInviteItemAction: () => {},
  closeTeamMemberInviteItemAction: () => {},
})
